import React, { useEffect, useRef, useState } from 'react';
import { TextArea as Ap4TextArea } from '@cb/apricot-react';

type TextAreaProps = React.ComponentProps<typeof Ap4TextArea> & {
  additionalInstructions?: string;
  errorMessage?: string;
  name: string;
  value: string;
};

export default function TextArea({
  additionalInstructions,
  errorMessage = '',
  name,
  onChange,
  value,
  ...props
}: TextAreaProps) {
  const [cursor, setCursor] = useState<number | null>(null);
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const input = ref.current;
    if (!input || cursor === null) return;
    try {
      input.setSelectionRange(cursor, cursor);
    } catch (err) {
      console.error('Error for setSelectionRange call in <TextArea>', err);
    }
  }, [cursor, value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCursor(e.target.selectionStart);
    onChange?.(e);
  };

  return (
    <>
      {additionalInstructions && (
        <p className='mb-0' id={`${name}-additionalLabel`}>
          {additionalInstructions}
        </p>
      )}
      <Ap4TextArea
        name={name}
        onChange={handleChange}
        ref={ref}
        validation={errorMessage ? 'error' : undefined}
        validationMsg={errorMessage ? errorMessage : ''}
        value={value}
        {...props}
      />
    </>
  );
}
